"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _breakpoints = _interopRequireDefault(require("../constants/breakpoints"));
var _default = function _default(objWithBreakpointsAsKeys) {
  return Object.keys(_breakpoints["default"]).filter(function (key) {
    return objWithBreakpointsAsKeys.hasOwnProperty(key);
  });
};
exports["default"] = _default;